<!-- Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.row {
    width: 100%;
    overflow: hidden;
    display: block;
    margin: 0;
}

.quizTopCTAs {
    display: flex;
    padding: 0;
    margin: 0;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    margin-bottom: 1rem;
    list-style-type: none;
    max-width: calc(100vw - 2rem);
    overflow: auto;
}

@media (min-width: 1024px) {
    .quizTopCTAs {
        margin-bottom: 2rem;
    }
}

.stepIndicator {
    max-width: 100%;
    height: 3.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
    box-sizing: border-box;
    border: 0;
    border-top: 0.25rem solid #fff;
    background-color: #757575;
    padding: 0 1.5rem;
    transition: transform 0.5s;
    opacity: 0.4;
    letter-spacing: 1.2px;
    white-space: nowrap;
}
.stepIndicator:hover {
    transform: translateY(-0.25rem);
    opacity: 0.6;
}
.stepIndicator.answered {
    opacity: 1;
}
.stepIndicator.answered:hover {
    background-color: #000;
    opacity: 1;
}
.stepIndicator.active {
    border-top: 0.25rem solid #ffffff;
    border-bottom: 0.0625rem solid #fff;
    opacity: 1;
}
.stepIndicator.active:hover {
    background-color: #000;
}
.stepIndicator.progress {
    float: right;
    min-width: 9.375rem;
    border-radius: 0;
}

.stepIndicator.answered.answereddisabled {
    cursor: initial;
}

.stepIndicator.active.answered {
    cursor: initial;
}
/** Light Theme (according to the template chosen) */
.quizTopCTAs.light .stepIndicator {
    color: #000;
    background-color: transparent;
    border-top: 0.25rem solid #000;
}
.quizTopCTAs.light .stepIndicator.answered:hover {
    background-color: #000;
    color: #fff;
}
.quizTopCTAs.light .stepIndicator.active {
    border-top: 0.25rem solid #000;
    border-bottom: 0.0625rem solid #000;
}

.stepbarcomponent-skipbutton {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 1;
    max-width: fit-content;
    padding: 0 1.5rem;
}
</style>

<template>
    <div class="d-none d-md-block">
        <!-- Steps bar for directional -->
        <div v-show="quizData.showStepTitle" class="row">
            <ul class="quizTopCTAs ti-scrollbar" :class="[this.lightTheme ? 'light' : '']">
                <li v-for="item in this.stepData.titles" v-bind:key="item.id">
                    <button
                        v-on:click="gotoQuestion(item.id, item.current, item.answered, isResultsPage)"
                        v-bind:class="[
                            item.id,
                            'stepIndicator ti-fs-16',
                            !isResultsPage && item.current ? 'active' : '',
                            item.answered ? 'answered' : 'unanswered',
                            !quizData.navBtns && item.answered ? 'answereddisabled' : '',
                        ]"
                        
                        v-bind:aria-disabled="!isResultsPage && !item.answered"
                        v-bind:aria-current="!isResultsPage && item.current ? 'step' : 'false'"
                    >
                        {{ isResultsPage && item.answersTitles[0] ? item.answersTitles[0] : item.title }}
                    </button>
                </li>
                <li
                    v-bind:class="['stepIndicator ti-fs-16', isResultsPage ? 'active' : '']"
                    v-bind:disabled="!isResultsPage"
                >
                    {{ stepSelectionText }}
                </li>
            </ul>
        </div>
        <button
            v-if="!isResultsPage && question.skippable"
            class="stepbarcomponent-skipbutton ti-btn ti-btn-pill ti-text-color-black"
            v-on:click="skipQuestion()"
        >
            {{ skipQuestionText }}
        </button>
    </div>
</template>

<script>
import { productSlider } from "@cartridges/cartridges/app_tissot/cartridge/client/default/js/components/productSlider";

export default {
    name: "StepsBarComponent",
    props: { isResultsPage: Boolean },
    computed: {
        quizData: function () {
            return this.$store.state.quizData;
        },
        question: function () {
            return this.$store.state.questionData;
        },
        stepData: function () {
            return this.$store.state.stepData;
        },
        stepSelectionText: function () {
            return this.$store.state.quizData.translations.stepTitleSelection;
        },
        skipQuestionText: function () {
            return this.$store.state.quizData.translations.skipQuestionText;
        },
        lightTheme: function () {
            return this.question.renderTemplate === "Template6" || this.isResultsPage;
        },
    },
    methods: {
        gotoQuestion: function (id, current, answered, isResultsPage) {
            if ((!current && answered && this.quizData.navBtns) || isResultsPage) {
                this.$store.dispatch("gotoQuestion", id);
            }
        },
        skipQuestion: function () {
            let data = {
                quizid: this.quizData.quizid,
                qid: this.question.id,
                aid: [""],
            };
            this.$store.dispatch("submitQuestion", data);
        },
    },
    mounted() {
        const carouselProducts = this.$store.state.showproductscarousel;

        // If no results, we display recommendations if there are, otherwise a no results message
        if (this.isResultsPage && !carouselProducts.length) {
            const quizInitElement = document.querySelector(".js-quiz-init");
            const finderProductsElement = quizInitElement.querySelector(".js-finder-products");
            const quizRecommendationsElement = quizInitElement.querySelector(".js-quiz-recommendations");
            const noResultsEl = quizInitElement.querySelector(".js-quiz-no-results");

            if (quizRecommendationsElement && quizRecommendationsElement.querySelectorAll(".swiper-slide").length > 0) {
                finderProductsElement.classList.add("d-none");
                const clonedEl = quizRecommendationsElement.cloneNode(true);
                clonedEl.classList.remove("d-none");
                finderProductsElement.parentNode.replaceChild(clonedEl, finderProductsElement);
                // reinit product sliders
                productSlider();
            } else {
                finderProductsElement.classList.add("d-none");
                const clonedEl = noResultsEl.cloneNode(true);
                clonedEl.classList.remove("d-none");
                finderProductsElement.parentNode.replaceChild(clonedEl, finderProductsElement);
            }
        }
    },
};
</script>
